var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"commonNumber",style:(_vm.frmStyle),attrs:{"type":"text","maxlength":_vm.frmMaxLength},domProps:{"value":_vm.fmtVal},on:{"input":_vm.onInput,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }